'use client';

/**
 * AI Suggestions — quick-reply chips that the assistant can suggest.
 *
 * When the assistant returns `suggestions: string[]`, these render as
 * clickable chips below the last assistant message. Clicking a chip sends
 * it as a new user message.
 *
 * Spec ref: docs/SPEC-174-1-PROFILEIA-AI-HUB.md §6.2.
 */

import { cn } from '@/lib/utils';

interface AISuggestionsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  disabled?: boolean;
}

export function AISuggestions({
  suggestions,
  onSelect,
  disabled = false,
}: AISuggestionsProps) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5 px-4 py-2" role="group" aria-label="Sugerencias de respuesta">
      {suggestions.map((suggestion, idx) => (
        <button
          key={idx}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(suggestion)}
          className={cn(
            'text-xs px-2.5 py-1.5 rounded-full border transition-colors',
            'border-primary/30 bg-primary/5 text-primary hover:bg-primary/10',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            'max-w-full truncate',
          )}
          title={suggestion}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
}
